import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { STATUS_CANCELED, TAED_EVENT_TYPE } from "../../util/constants";
import { isBaseScheduleAdded } from "../../util/taedUtils";
import SlideUpTransition from "../fundamentals/SlideUpTransition";
import StarsCloseIconButton from "../fundamentals/StarsCloseIconButton.jsx";
import PropTypes from "prop-types";
import { getStationTimeZoneDateTimeStringFromUTCInteger } from "../../util/timeZoneService";

const TemporaryAssignmentAuditHistoryDialog = (props) => {
  const tempAssignmentEvents = props.tempAssignmentEvents;

  const handleClickDialogClose = () => {
    props.setDialogOpen(false);
  };

  const renderBaseSchedule = (day, index) => {
    return (
      <div>
        {!isBaseScheduleAdded(tempAssignmentEvents[index].baseSchedule) ? (
          ""
        ) : tempAssignmentEvents[index].baseSchedule[day].isOFF ? (
          <div className="detail-dialog-right-text">OFF</div>
        ) : tempAssignmentEvents[index].baseSchedule[day].isNA ? (
          <div className="detail-dialog-right-text">N/A</div>
        ) : (
          <div className="detail-dialog-right-text">
            {tempAssignmentEvents[index].baseSchedule[day].start.hr}:
            {tempAssignmentEvents[index].baseSchedule[day].start.min}-
            {tempAssignmentEvents[index].baseSchedule[day].end.hr}:
            {tempAssignmentEvents[index].baseSchedule[day].end.min}
          </div>
        )}
      </div>
    );
  };
  const getEventCreateDate = (timestamp, tempStation) => {
    return getStationTimeZoneDateTimeStringFromUTCInteger(timestamp, tempStation).toFormat("LLLL dd, yyyy T ZZZZ");
  };
  const getEventDate = (date) => {
    const newDate = date.split("-");
    const formatedDate = newDate[1] + "/" + newDate[2] + "/" + newDate[0];
    return formatedDate;
  };
  return (
    <Dialog
      className="detail-dialog"
      data-testid="temporary-assignment-information-dialog"
      open={props.isDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <StarsCloseIconButton onClick={handleClickDialogClose} />
      </DialogTitle>
      <DialogContent className="detail-dialog-content">
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <Grid container>
            <Grid item xs={12}>
              <Typography component={"div"}>
                <Box className="detail-dialog-section-title">Audit History</Box>
              </Typography>
              {tempAssignmentEvents.map((events, index) => {
                return events.status === STATUS_CANCELED ? (
                  <Paper className="detail-dialog-section">
                    <Grid container>
                      <Grid className="detail-dialog-section-title" item xs={6}>
                        <div>{STATUS_CANCELED}</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text detail-dialog-section-title">
                          {events.modifiedByLastName}, {events.modifiedByFirstName}
                        </div>
                      </Grid>
                      <Grid item>
                        <div className="detail-dialog-right-text">
                          <b>{getEventCreateDate(events.createdAt, events.tempStation)}</b>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>Comments</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{events.comments}</div>
                      </Grid>
                    </Grid>
                  </Paper>
                ) : (
                  <Paper className="detail-dialog-section">
                    <Grid container>
                      {events.eventType === "STATUS_UPDATE" ? (
                        <Grid>
                          <Grid className="detail-dialog-section-title" item xs={6}>
                            <div>{events.status}</div>
                          </Grid>
                          <Grid item>
                            <div className="detail-dialog-right-text">
                              <b>{getEventCreateDate(events.customCreatedAt, events.tempStation)}</b>
                            </div>
                          </Grid>
                        </Grid>
                      ) : (
                        <>
                          <Grid className="detail-dialog-section-title" item xs={6}>
                            <div>{events.eventType === TAED_EVENT_TYPE.EDIT ? "Updated" : "Created"}</div>
                          </Grid>
                          <Grid item xs={6}>
                            <div className="detail-dialog-right-text detail-dialog-section-title">
                              {events.modifiedByLastName}, {events.modifiedByFirstName}
                            </div>
                          </Grid>
                          <Grid item>
                            <div className="detail-dialog-right-text">
                              <b>{getEventCreateDate(events.createdAt, events.tempStation)}</b>
                            </div>
                          </Grid>
                        </>
                      )}
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>Contact #</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{events.contactNumber}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>Dates</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">
                          {getEventDate(events.startDate)} - {getEventDate(events.endDate)}
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>SUN</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{renderBaseSchedule("SUN", index)}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>MON</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{renderBaseSchedule("MON", index)}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>TUE</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{renderBaseSchedule("TUE", index)}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>WED</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{renderBaseSchedule("WED", index)}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>THU</div>
                      </Grid>

                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{renderBaseSchedule("THU", index)}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>FRI</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{renderBaseSchedule("FRI", index)}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>SAT</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{renderBaseSchedule("SAT", index)}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={6}>
                        <div>Comments</div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{events.comments}</div>
                      </Grid>
                    </Grid>
                  </Paper>
                );
              })}
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

TemporaryAssignmentAuditHistoryDialog.propTypes = {
  tempAssignment: PropTypes.object.isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
};

export default TemporaryAssignmentAuditHistoryDialog;
